const indexItems = [
  { title: '娱乐圈塌房全记录', desc: '按时间线梳理近年来娱乐圈明星塌房事件全过程', count: '38篇', icon: 'ri-collapse-diagonal-line' },
  { title: '网红翻车现场实录', desc: '各大网红翻车名场面合集，吃瓜必备经典回顾', count: '52篇', icon: 'ri-emotion-line' },
  { title: '综艺节目内幕揭秘', desc: '深度曝光热门综艺的台前幕后那些不为人知的秘密', count: '27篇', icon: 'ri-tv-line' },
  { title: '品牌代言人翻车史', desc: '盘点那些因代言人负面而受到重创的知名品牌事件', count: '19篇', icon: 'ri-store-line' },
  { title: '影视剧拍摄轶事', desc: '片场趣闻、演员纠纷、制作内幕，带你看到镜头之外', count: '44篇', icon: 'ri-film-line' },
  { title: '直播带货乱象榜', desc: '直播行业虚假宣传、售假翻车等问题的综合调查报告', count: '31篇', icon: 'ri-live-line' },
  { title: '选秀节目暗箱操作', desc: '投票造假、内定冠军、导师潜规则等选秀节目黑幕合集', count: '23篇', icon: 'ri-mic-line' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1100px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按主题分类的黑料专题，帮你快速找到想吃的瓜
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="flex items-start gap-4 p-5 bg-background-100 rounded-xl border border-secondary-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group"
            >
              <span className="w-11 h-11 flex items-center justify-center bg-accent-100 text-accent-700 rounded-xl flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
                <span className="inline-block mt-2 text-[11px] text-primary-600 font-medium">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
          {indexItems.length % 3 !== 0 && (
            <a
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="hidden lg:flex items-center justify-center p-5 bg-background-100 rounded-xl border border-dashed border-secondary-300 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm text-foreground-400">
                <i className="ri-add-line mr-1"></i>
                更多专题
              </span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}